import * as yup from "yup";

const userValidationSchema = (isEditEntity: boolean) => {
    return yup.object().shape({
        name: yup.string().required("ПІБ пацієнта обов'язкове"),
        email: yup
            .string()
            .email("Невірний формат введення пошти")
            .required("Електронна пошта обов'язкова"),
        password: isEditEntity
            ? yup.string().optional()
            : yup
                  .string()
                  .required("Пароль обов'язковий")
                  .min(6, "Пароль повинен містити щонайменше 6 символів"),
        passwordConfirm: isEditEntity
            ? yup
                  .string()
                  .optional()
                  .oneOf([yup.ref("password")], "Паролі повинні співпадати")
            : yup
                  .string()
                  .required("Підтвердження пароля обов'язкове")
                  .oneOf([yup.ref("password")], "Паролі повинні співпадати"),
        roleInClinic: yup
            .mixed<"doctor" | "admin">()
            .oneOf(["doctor", "admin"], "Невірна роль користувача")
            .default("doctor"),
    });
};

export default userValidationSchema;
